import { initiateLiveChat, makeTrackLiveChat } from '../../../helpers/chat/live-chat.helper';
import { useTrackEvent } from '../analytics.hooks';

export const useLiveChat = () => {
	const trackEvent = useTrackEvent();
	const trackLiveChat = makeTrackLiveChat(trackEvent);

	return () => initiateLiveChat(trackLiveChat);
};
